import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnableShippingOptionsForDefaultRateShoppers = (): boolean => {
  return useFeatureFlag(FeatureFlagDeclarations.enableShippingOptionsForDefaultRateShoppers);
};
